import PAButton from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import Router from "next/router";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import styles from "./link-card.module.scss";

function LinkCard(props: any) {
  const {
    title, imageUrl, subheading, link, hideButton = false, subSubHeading, headingSize = 3, subHeadingSize = 4, textClassName,
  } = props;
  const { t } = useTranslation("static-pages");
  return (
    <div className={`${styles.card_container}`}>
      <PAText component="h2" color="black" bold fontSize={headingSize} className="text-center p-b-20">{title}</PAText>
      <div className={`${styles.icon_background}`}>
        <PAImage
          src={getRelativeImagePath(imageUrl)}
          alt={title}
          title={title}
          height={150}
          width={150}
          className={`${styles.eachImageCard}`}
        />
      </div>
      <HideIf show={subheading}>
        <PAText className="text-center p-t-10  p-b-20 d-flex w-100 justify-content-center" color="grey" fontSize={FONT_SIZE[2]}>{subheading}</PAText>
      </HideIf>
      <HideIf show={!hideButton}>
        <PAButton onClick={() => Router.push(`${link}`)} style={{ width: "auto" }}>
          {t("Learn more")}
        </PAButton>
      </HideIf>
    </div>
  );
}

export default LinkCard;
